import apiService, { API_ENDPOINTS } from "../utils/apiInterceptor";

// Dashboard Service - handles all dashboard-related API calls
export const dashboardService = {
  // Get dashboard statistics
  getStats: async () => {
    try {
      return await apiService.get(API_ENDPOINTS.DASHBOARD.STATS);
    } catch (error) {
      throw error;
    }
  },

  // Get recent activity
  getActivity: async (limit = 10) => {
    try {
      return await apiService.get(
        `${API_ENDPOINTS.DASHBOARD.ACTIVITY}?limit=${limit}`
      );
    } catch (error) {
      throw error;
    }
  },

  // Get dashboard reports
  getReports: async (dateRange = {}) => {
    try {
      return await apiService.post(API_ENDPOINTS.DASHBOARD.REPORTS, dateRange);
    } catch (error) {
      throw error;
    }
  },

  // Get call statistics
  getCallStats: async (period = "month") => {
    try {
      return await apiService.get(
        `${API_ENDPOINTS.CALLS.STATS}?period=${period}`
      );
    } catch (error) {
      throw error;
    }
  },

  // Get recent calls
  getRecentCalls: async (limit = 10) => {
    try {
      return await apiService.get(
        `${API_ENDPOINTS.CALLS.RECENT}?limit=${limit}`
      );
    } catch (error) {
      throw error;
    }
  },

  // Get user activity summary
  getUserActivity: async (userId, period = "week") => {
    try {
      return await apiService.get(
        `/api/users/${userId}/activity?period=${period}`
      );
    } catch (error) {
      throw error;
    }
  },

  // Get system health metrics
  getSystemHealth: async () => {
    try {
      return await apiService.get("/api/system/health");
    } catch (error) {
      throw error;
    }
  },
};

export default dashboardService;
